import KPOP from "../../images/Icons/KPOP@2x.png";
import Unemployment from "../../images/Icons/Unemployment@2x.png";
import Calculator from "../../images/Icons/Calculator@2x.png";
import Piano from "../../images/Icons/Piano@2x.png";
import Bookshelf from "../../images/Icons/Bookshelf@2x.png";
import Boot from "../../images/Icons/Boot@2x.png";
import Coffee from "../../images/Icons/Coffee@2x.png";
import Cake from "../../images/Icons/Cake@2x.png";
import Truck from "../../images/Icons/Truck@2x.png";
import Waffle from "../../images/Icons/Waffle@2x.png";

const questions = [
  {
    id: 1,
    title: "Concert tickets for Korean pop band",
    desc: "You buy concert tickets for your favorite Korean pop band performing this year in California.",
    answer: "yes",
    icon: KPOP,
    wrongAnswerText: "Incorrect. This is a service produced this year within the US, so it counts towards U.S. GDP, even if the artists are not from the U.S.",
    rightAnswerText: "Correct. This is a service produced this year within the U.S., so it counts towards U.S. GDP, even if the artists are not from the U.S.",
  },
  {
    id: 2,
    title: "Unemployment Benefits",
    desc: "Your cousin Joe receives his first unemployment check after getting laid off from a tech startup.",
    answer: "no",
    icon: Unemployment,
    wrongAnswerText: "Not quite! Income transfers are not included in the government spending portion of GDP to avoid double counting. When Joe spends his money on final goods and services, those purchases will count towards GDP.",
    rightAnswerText: "Correct! Income transfers are not included in the government spending portion of GDP to avoid double counting. When Joe spends his money on final goods and services, those purchases will count towards GDP.",
  },
  {
    id: 3,
    title: "TI-84",
    desc: "Your parents save $100 by giving you your older brother's TI-84 calculator they've saved in a drawer for 2 years for you to use this year in your calculus class.",
    answer: "no",
    icon: Calculator,
    wrongAnswerText: "Not quite! You're reusing an old good, so it does not count towards GDP.",
    rightAnswerText: "Correct! You're reusing an old good, so it does not count towards GDP.",
  },
  {
    id: 4,
    title: "Piano Lessons",
    desc: "Your parents pay for this month's piano lessons at a local music school.",
    answer: "yes",
    icon: Piano,
    wrongAnswerText: "Incorrect. The piano lessons are final services produced this year in the U.S., so they count towards U.S. GDP.",
    rightAnswerText: "Correct! The piano lessons are final services produced this year in the U.S., so they count towards U.S. GDP.",
  },
  {
    id: 5,
    title: "Ikea Billy Bookcase",
    desc: "You buy an IKEA Billy bookshelf, designed and manufactured this year in Sweden, for your bedroom to keep your textbooks organized.",
    answer: "no",
    icon: Bookshelf,
    wrongAnswerText: "Incorrect. Since the bookshelf was made in Sweden this year, the bookshelf counts towards Sweden's GDP.",
    rightAnswerText: "Correct! Since the bookshelf was made in Sweden this year, the bookshelf counts towards Sweden's GDP.",
  },
  {
    id: 6,
    title: "L.L. Bean Duck Boots",
    desc: "You buy a pair of handmade L.L. Bean duck boots made this year in Maine.",
    answer: "yes",
    icon: Boot,
    wrongAnswerText: "Not quite! The boots are a final good made this year in the U.S, so they count towards this year's GDP.",
    rightAnswerText: "Correct! The boots are a final good made this year in the U.S., so they count towards this year's GDP.",
  },
  {
    id: 7,
    title: "Kona Coffee",
    desc: "Your local coffee shop purchases Kona coffee beans to serve in their cafe as a premium offering.",
    answer: "no",
    icon: Coffee,
    wrongAnswerText: "Not quite! The beans are an intermediate good, so they are not included in GDP. When the coffee shop sells cups of Kona coffee, the purchase price of the cups will be included in GDP.",
    rightAnswerText: "Correct! The beans are an intermediate good, so they are not included in GDP. When the coffee shop sells cups of Kona coffee, the purchase price of the cups will be included in GDP.",
  },
  {
    id: 8,
    title: "Wedding cake",
    desc: "You are a professional baker and gift your friend a custom wedding cake (worth $500!) free of charge.",
    answer: "no",
    icon: Cake,
    wrongAnswerText: "Not quite! Since the wedding cake was free, it does not count towards GDP.",
    rightAnswerText: "Correct! Since the wedding cake was free, it does not count towards GDP.",
  },
  {
    id: 9,
    title: "Caterpillar Mining Truck",
    desc: "A South African mining operator buys a Caterpillar mining truck manufactured in Illinois this year.",
    answer: "yes",
    icon: Truck,
    wrongAnswerText: "Not quite! Since the truck was made in the U.S. this year, it counts towards U.S. GDP.",
    rightAnswerText: "Correct! Since the truck was made in the U.S. this year, it counts towards U.S. GDP.",
  },
  {
    id: 10,
    title: "Waffles",
    desc: "You buy waffles while studying for finals at Waffle House.",
    answer: "yes",
    icon: Waffle,
    wrongAnswerText: "Not quite! The waffles were made in the US this year, and are a final good. They count towards U.S. GDP.",
    rightAnswerText: "Correct! The waffles were made in the U.S. this year, and are a final good. They count towards U.S. GDP.",
  },
];

export default questions;
